exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Popovers-52e29bd4{position:relative}.demoContainer-3fbb53b9{margin:100px 0}\n", ""]);

// Exports
exports.locals = {
	"Popovers": "Popovers-52e29bd4",
	"demoContainer": "demoContainer-3fbb53b9"
};